<template>
    <b-card no-body class="nsp-card">
        <b-card-header class="d-flex align-items-center">
            <span class="nsp-title">{{ module.moduleName || $t('NSP_WEATHER') }}</span>
            <b-badge v-if="stale" class="ml-auto" variant="warning">{{ $t('NSP_WEATHER_STALE') }}</b-badge>
            <span v-else class="ml-auto small text-muted">{{ age }}</span>
        </b-card-header>

        <b-card-body>
            <div class="d-flex align-items-center mb-3">
                <div class="nsp-big">{{ show(module.temperature, 1) }}<small>&#8451;</small></div>
                <div class="ml-4">
                    <div class="small text-muted">{{ $t('NSP_DEW_POINT') }}</div>
                    <div>{{ show(num('dew_point'), 1) }}&#8451;</div>
                </div>
                <div class="ml-4">
                    <div class="small text-muted">{{ $t('NSP_HUMIDITY') }}</div>
                    <div>{{ show(num('humidity'), 0) }}%</div>
                </div>
            </div>

            <div class="nsp-weather-grid">
                <div v-for="tile in tiles" :key="tile.key">
                    <div class="small text-muted">{{ tile.label }}</div>
                    <div class="nsp-weather-value">{{ tile.value }}</div>
                </div>
            </div>
        </b-card-body>

        <!-- whatever the screen wants under the readings, on the house screen
             this is the history panel -->
        <slot name="footer"></slot>
    </b-card>
</template>

<script>
import sensorCard from './sensorCard';

// 16 point compass, wind_direction comes in degrees
const COMPASS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE',
    'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

export default
{
    name: 'WeatherCard',
    mixins: [sensorCard],
    data()
    {
        return {
            // the station reports every nine seconds, so anything older than this
            // means the station or the service stopped
            staleMinutes: 5,
        };
    },
    computed:
    {
        tiles()
        {
            const me = this;
            const raining = (me.num('rain_status') > 0);

            return [
                { key: 'wind', label: me.$t('NSP_WIND'), value: `${me.show(me.num('wind_speed'), 1)} m/s` },
                { key: 'gust', label: me.$t('NSP_GUST'), value: `${me.show(me.num('gust_speed'), 1)} m/s` },
                { key: 'dir', label: me.$t('NSP_WIND_DIRECTION'), value: me.compass(me.num('wind_direction')) },
                { key: 'lux', label: me.$t('NSP_ILLUMINANCE'), value: me.show(me.num('illuminance'), 0) },
                { key: 'uv', label: me.$t('NSP_UV'), value: me.show(me.num('uv'), 0) },
                { key: 'pressure', label: me.$t('NSP_PRESSURE'), value: `${me.show(me.num('pressure'), 0)} hPa` },
                { key: 'rain', label: me.$t('NSP_RAIN'), value: raining ? me.$t('NSP_YES') : me.$t('NSP_NO') },
                { key: 'battery', label: me.$t('NSP_BATTERY'), value: `${me.show(me.num('battery'), 0)}%` },
            ];
        },
    },
    methods:
    {
        compass(degrees)
        {
            const me = this;

            if (degrees === null)
            {
                return '-';
            }

            const point = COMPASS[Math.round((degrees % 360) / 22.5) % 16];

            return `${point} ${me.show(degrees, 0)}°`;
        },
    },
};
</script>
